/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const GoogleColor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Google color"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Mask group">
      <mask
        id="a"
        width={20}
        height={20}
        x={2}
        y={2}
        className="a"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <g className="Group">
          <path
            fill="#E94FFF"
            d="M21.609 10.181h-9.414v3.864h5.375a4.6 4.6 0 0 1-1.992 3.026c-.893.6-2.041.95-3.383.95-2.599 0-4.803-1.754-5.59-4.12a6 6 0 0 1 0-3.805c.787-2.365 2.991-4.12 5.59-4.12 1.467 0 2.782.506 3.819 1.495l2.861-2.865C17.146 2.99 14.89 2 12.195 2A9.984 9.984 0 0 0 2.21 12c0 1.616.383 3.14 1.062 4.491A9.98 9.98 0 0 0 12.195 22c2.695 0 4.964-.886 6.617-2.414 1.887-1.74 2.971-4.316 2.971-7.358q-.002-1.066-.174-2.046"
            className="Vector"
          />
        </g>
      </mask>
      <g className="Group" mask="url(#a)">
        <g className="Group" filter="url(#b)">
          <g clipPath="url(#c)" data-figma-skip-parse="true">
            <foreignObject
              width={3504.8}
              height={3504.8}
              x={-1752.4}
              y={-1752.4}
              transform="matrix(.00804 -.00805 .00804 .00805 11.893 11.783)"
            >
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,#ff4641 0deg,#ff4641 4.14555deg,#3186ff 39.154deg,#3186ff 72.0044deg,#00a5b7 96.7463deg,#0ebc5f 120.897deg,#0ebc5f 154.722deg,#6cc400 179.136deg,#fc0 203.588deg,#ffd314 226.915deg,#fc0 251.688deg,#ff6a2b 273.129deg,#fd4641 289.305deg,#ff4641 359.593deg,#ff4641 360deg)',
                  height: '100%',
                  width: '100%',
                }}
              />
            </foreignObject>
          </g>
          <path
            d="M-.53 11.793c0-7.117 5.762-12.886 12.869-12.886s12.869 5.77 12.869 12.886c0 7.117-5.762 12.886-12.869 12.886S-.53 18.91-.53 11.793"
            className="Vector"
            data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.011515417136251926},{"color":{"r":0.19215686619281769,"g":0.52549022436141968,"b":1.0,"a":1.0},"position":0.10876122117042542},{"color":{"r":0.19215686619281769,"g":0.52549022436141968,"b":1.0,"a":1.0},"position":0.20001229643821716},{"color":{"r":0.0,"g":0.64705884456634521,"b":0.71764707565307617,"a":1.0},"position":0.26873961091041565},{"color":{"r":0.054901961237192154,"g":0.73725491762161255,"b":0.37254902720451355,"a":1.0},"position":0.33582508563995361},{"color":{"r":0.054901961237192154,"g":0.73725491762161255,"b":0.37254902720451355,"a":1.0},"position":0.42978334426879883},{"color":{"r":0.42528781294822693,"g":0.77231442928314209,"b":0.0,"a":1.0},"position":0.49760133028030396},{"color":{"r":1.0,"g":0.80000001192092896,"b":0.0,"a":1.0},"position":0.56552332639694214},{"color":{"r":1.0,"g":0.82745099067687988,"b":0.078431375324726105,"a":1.0},"position":0.63031959533691406},{"color":{"r":1.0,"g":0.80000001192092896,"b":0.0,"a":1.0},"position":0.69913208484649658},{"color":{"r":1.0,"g":0.41842123866081238,"b":0.16917318105697632,"a":1.0},"position":0.75869029760360718},{"color":{"r":0.99215686321258545,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.80362409353256226},{"color":{"r":1.0,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.99887031316757202}],"transform":{"m00":16.082571029663086,"m01":16.082569122314453,"m02":-4.1899080276489258,"m10":-16.103721618652344,"m11":16.103721618652344,"m12":11.793211936950684},"opacity":1.0,"blendMode":"NORMAL","stopsVar":[{"color":{"r":1.0,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.011515417136251926},{"color":{"r":0.19215686619281769,"g":0.52549022436141968,"b":1.0,"a":1.0},"position":0.10876122117042542},{"color":{"r":0.19215686619281769,"g":0.52549022436141968,"b":1.0,"a":1.0},"position":0.20001229643821716},{"color":{"r":0.0,"g":0.64705884456634521,"b":0.71764707565307617,"a":1.0},"position":0.26873961091041565},{"color":{"r":0.054901961237192154,"g":0.73725491762161255,"b":0.37254902720451355,"a":1.0},"position":0.33582508563995361},{"color":{"r":0.054901961237192154,"g":0.73725491762161255,"b":0.37254902720451355,"a":1.0},"position":0.42978334426879883},{"color":{"r":0.42528781294822693,"g":0.77231442928314209,"b":0.0,"a":1.0},"position":0.49760133028030396},{"color":{"r":1.0,"g":0.80000001192092896,"b":0.0,"a":1.0},"position":0.56552332639694214},{"color":{"r":1.0,"g":0.82745099067687988,"b":0.078431375324726105,"a":1.0},"position":0.63031959533691406},{"color":{"r":1.0,"g":0.80000001192092896,"b":0.0,"a":1.0},"position":0.69913208484649658},{"color":{"r":1.0,"g":0.41842123866081238,"b":0.16917318105697632,"a":1.0},"position":0.75869029760360718},{"color":{"r":0.99215686321258545,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.80362409353256226},{"color":{"r":1.0,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.99887031316757202}],"visible":true}'
          />
        </g>
        <g className="Group" filter="url(#d)">
          <path
            fill="#3186FF"
            d="M11.086 14.823c2.714 1.234 5.438 1.078 6.086-.348.648-1.425-1.026-3.58-3.739-4.814s-5.438-1.078-6.086.348c-.648 1.425 1.026 3.58 3.74 4.814"
            className="Vector"
          />
        </g>
        <g className="Group" filter="url(#e)">
          <path
            fill="#3186FF"
            d="M25.564 13.31c4.109 0 7.44-1.386 7.44-3.094 0-1.709-3.331-3.094-7.44-3.094-4.108 0-7.439 1.385-7.439 3.094s3.33 3.093 7.44 3.093"
            className="Vector"
          />
        </g>
        <g className="Group" filter="url(#f)">
          <path
            fill="#FF4641"
            d="M17.485 10.598c4.092 0 7.409-1.065 7.409-2.378s-3.317-2.378-7.409-2.378-7.409 1.064-7.409 2.378c0 1.313 3.317 2.378 7.409 2.378"
            className="Vector"
          />
        </g>
        <g className="Group" filter="url(#g)">
          <path
            fill="#FF5B8B"
            d="M21.753 7.305c4.091 0 7.408-1.065 7.408-2.378s-3.317-2.378-7.408-2.378-7.409 1.065-7.409 2.378 3.317 2.378 7.409 2.378"
            className="Vector"
          />
        </g>
        <g className="Group" filter="url(#h)">
          <path
            fill="#3186FF"
            d="M16.692 14.988c4.698 0 8.506-1.392 8.506-3.11s-3.808-3.11-8.506-3.11-8.506 1.393-8.506 3.11c0 1.718 3.808 3.11 8.506 3.11"
            className="Vector"
          />
        </g>
        <g className="Group" filter="url(#i)">
          <path
            fill="#FF4641"
            d="M18.535 8.107c2.2-1.202 3.472-3.111 2.842-4.264-.63-1.152-2.924-1.112-5.123.09S12.78 7.045 13.41 8.197s2.924 1.112 5.124-.09"
            className="Vector"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="b"
        width={29.738}
        height={29.772}
        x={-2.53}
        y={-3.093}
        className="b"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_28670_1534"
          stdDeviation={1}
        />
      </filter>
      <filter
        id="d"
        width={14.104}
        height={10.826}
        x={5.208}
        y={6.829}
        className="d"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_28670_1534"
          stdDeviation={1}
        />
      </filter>
      <filter
        id="e"
        width={18.878}
        height={10.187}
        x={16.125}
        y={5.122}
        className="e"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_28670_1534"
          stdDeviation={1}
        />
      </filter>
      <filter
        id="f"
        width={18.817}
        height={8.756}
        x={8.076}
        y={3.842}
        className="f"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_28670_1534"
          stdDeviation={1}
        />
      </filter>
      <filter
        id="g"
        width={18.817}
        height={8.756}
        x={12.344}
        y={0.549}
        className="g"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_28670_1534"
          stdDeviation={1}
        />
      </filter>
      <filter
        id="h"
        width={21.012}
        height={10.22}
        x={6.186}
        y={6.769}
        className="h"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_28670_1534"
          stdDeviation={1}
        />
      </filter>
      <filter
        id="i"
        width={12.288}
        height={10.031}
        x={11.25}
        y={1.005}
        className="i"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_28670_1534"
          stdDeviation={1}
        />
      </filter>
      <clipPath id="c" className="c">
        <path
          d="M-.53 11.793c0-7.117 5.762-12.886 12.869-12.886s12.869 5.77 12.869 12.886c0 7.117-5.762 12.886-12.869 12.886S-.53 18.91-.53 11.793"
          className="Vector"
        />
      </clipPath>
    </defs>
  </svg>
);

export const GoogleColorIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'google-color-icon'}
      icon={GoogleColor}
      {...props}
      size={size}
    />
  );
};
